import { Injectable } from '@angular/core';
import { AuthDataService } from "../api/auth-data.service"

@Injectable({
    providedIn: 'root'
})

export class AuthService {
    constructor(private authDataService: AuthDataService) { }
    // Login Data
    public login(loginData) {
        return this.authDataService.login(loginData);
    }
    // Forget Password
    public ForgetPassword(data) {
        return this.authDataService.ForgetPassword(data);
    }

    // Verify ResetToken
    public verifyResetToken(token) {
        return this.authDataService.verifyResetToken(token);
    }

    //Reset password
    public resetPassword(data) {
        return this.authDataService.resetPassword(data);
    }

    // Change Password
    public changePassword(data) {
        return this.authDataService.changePassword(data);
    }

    // Forgot Username 
    public requestForgotUsername(data) {
        return this.authDataService.requestForgotUsername(data);
    }
    logout(data: { access_token: string | null; }) {
        throw new Error('Method not implemented.');
    }
}